import React from 'react'

function TenderTextSCF() {
  return (
    <embed src="\pdfs\EA1.1.1_scf-hightec-triple-s_text_for_tender_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextSCF